import React from "react";
import { gotoUrl } from "utils/helpers";
import { Box, Button, Text } from "ui-components";

const MockedAuConsentScreen = () => {
  const onClickConfirmBtn = () => {
    gotoUrl("web/select-email");
  };

  return (
    <Box mb="2rem" textAlign="center">
      <Text mb="4rem" lineHeight="1.2">
        This is a dummy page for au lost service Page
      </Text>
      <Button mt="4rem" onClick={onClickConfirmBtn}>
        CONFIRM
      </Button>
    </Box>
  );
};
export default MockedAuConsentScreen;
